module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/theme-pic01@3x-403f8bb32088fda1c01f5a9b2efd1143.png";